import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { Link, useSearchParams } from "react-router-dom";

import BasicInfo from "./BasicInfo";
import BooksInfo from "./BooksInfo";
import TaleTab from "./TaleTab";
import AIGeneratedTaleTab from "./AIGeneratedTaleTab";
import FollowersTab from "./FollowersTab";
import FollowingTab from "./FollowingTab";
import CharacterTab from "./CharacterTab";

export default function Viewuser() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [key, setKey] = useState(searchParams.get("tab") || "basicinfo");

  useEffect(() => {
    const currentTab = searchParams.get("tab") || "basicinfo";
    setKey(currentTab); // 💡 Update tab if URL param changes
  }, [searchParams]);

  const handleSelect = (k) => {
    setKey(k);
    setSearchParams({ tab: k });
  };

  return (
    <React.Fragment>
      <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between mb-4">
        <Tabs
          activeKey={key}
          onSelect={handleSelect}
          className="customtabsbox"
        >
          <Tab eventKey="basicinfo" title="Basic Info" />
          <Tab eventKey="Books" title="Books" />
          <Tab eventKey="Tales" title="Tales" />
          <Tab eventKey="AIGeneratedStories" title="AI Generated Stories" />
          <Tab eventKey="Characters" title="Characters" />
          <Tab eventKey="Followers" title="Followers" />
          <Tab eventKey="Following" title="Following" />
        </Tabs>
        <Link
          className="btn btn-primary-light d-inline-flex align-items-center justify-content-center px-4 min_width140"
          to="/Users"
        >
          Back
        </Link>
      </div>

      {key === "basicinfo" && <BasicInfo />}
      {key === "Books" && <BooksInfo />}
      {key === "Tales" && <TaleTab />}
      {key === "AIGeneratedStories" && <AIGeneratedTaleTab />}
      {key === "Characters" && <CharacterTab />}
      {key === "Followers" && <FollowersTab />}
      {key === "Following" && <FollowingTab />}
    </React.Fragment>
  );
}
